export default {
  specification: 'specification',
};
